import Model, { belongsTo, attr } from '@ember-data/model';

export default class SchoolPreferenceModel extends Model {
  @belongsTo('school', { async: true, inverse: 'schoolPreference' })
  school;

  @attr('boolean')
  aiOptIn;
}
